import { Injectable } from '@angular/core';
import { Topic } from '@parashift/shared/models';
import { TopicType } from '@parashift/shared/types';
import { ServiceDecorator } from './decorators';
import { BaseApiService } from './base';
import { Endpoint } from '../env.service';

@Injectable({
  providedIn: 'root'
})
@ServiceDecorator({
  model: () => Topic,
  endpointUrl: TopicType
})
export class TopicService extends BaseApiService<Topic> {
  className = TopicService;

  constructor() {
    super();
    this.baseUrl = Endpoint.webhooks;
    this.apiVersion = this.environment.endpoints.version
  }
}
